import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";

interface Props {
  label?: string;
  to?: string;
}

export function BackToInvoicesLink({
  label = "Back to invoices",
  to = "/app",
}: Props) {
  return (
    <Link
      to={to}
      className="mb-4 inline-flex min-h-10 items-center gap-2 rounded-xl px-3 text-sm font-semibold text-ink-muted hover:bg-surface-muted hover:text-ink"
    >
      <ArrowLeft className="h-4 w-4" />
      {label}
    </Link>
  );
}
